import { useCallback } from "react";
import { useWatch } from "react-hook-form";
import type { ID } from "common/utils/models";
import { useCompositionForm } from "./useCompositionForm";

export function useVariants() {
  const { form } = useCompositionForm();
  const addedCompositions = useWatch({
    control: form.control,
    name: "addedCompositions"
  });

  const getVariantQuantity = useCallback(
    (compositionId: ID, variantId: ID) => {
      const comp = addedCompositions.find(c => c.id === compositionId);
      if (!comp) return 0;
      const variant = comp.variants[variantId];
      return variant || 0;
    },
    [addedCompositions]
  );

  return { getVariantQuantity };
}
